import { api } from './api';

export interface JobMetrics {
  jobName: string;
  executionCount: number;
  successCount: number;
  failureCount: number;
  lastStartTime: string | null;
  lastSuccessTime: string | null;
  lastFailureTime: string | null;
  lastDurationMs: number;
  totalDurationMs: number;
  consecutiveFailures: number;
  lastError: string | null;
}

export interface HealthStatus {
  status: string;
  totalExecutions: number;
  totalFailures: number;
  failureRate: number;
  jobsWithFailures: number;
  totalJobs: number;
}

export const jobService = {
  async getHealthStatus(): Promise<HealthStatus> {
    const response = await api.get<HealthStatus>('/coreapi/jobs/health');
    return response.data;
  },

  async getAllJobMetrics(): Promise<Record<string, JobMetrics>> {
    const response = await api.get<Record<string, JobMetrics>>('/coreapi/jobs/metrics');
    return response.data;
  },

  async getJobMetrics(jobName: string): Promise<JobMetrics> {
    const response = await api.get<JobMetrics>(`/coreapi/jobs/metrics/${jobName}`);
    return response.data;
  },

  async triggerJob(jobType: string): Promise<{ status: string; message: string }> {
    const response = await api.post<{ status: string; message: string }>(`/coreapi/admin/jobs/${jobType}/trigger`);
    return response.data;
  },
};
